// Entry point for the build script in your package.json
import * as bootstrap from "bootstrap"
import "./controllers"

// Initialize Bootstrap dropdowns explicitly
document.addEventListener("turbo:load", () => {
  const dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
  dropdownElementList.map(function (dropdownToggleEl) {
    return new bootstrap.Dropdown(dropdownToggleEl);
  });
});
